import {
  Component,
  OnInit,
  DoCheck,
  AfterViewInit,
  OnChanges,
  ViewChild,
  ViewChildren,
  QueryList,
  OnDestroy,
  ElementRef,
} from "@angular/core";
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from "@angular/material/tree";
import {
  of as observableOf,
  Observable,
  of,
  Subscription,
  throwError,
} from "rxjs";
import { FlatTreeControl } from "@angular/cdk/tree";
import { files } from "../_models/example-data";
import { ProjectService } from "../_services/project.service";
import { TestService } from "../_services/test.service";
import { ToastrService } from "ngx-toastr";
import { beatBlipSubscriptionConsts } from "../consts/beatBlipSubscriptionConsts";
import { DOCUMENT } from "@angular/common";
import { Inject } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { ActivatedRoute, Router } from "@angular/router";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  NgForm,
  Validators,
  FormControl,
} from "@angular/forms";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map, find, switchMap } from "rxjs/operators";
import { UserMgmtService } from "../_services/user-mgmt.service";
import { UserService } from "../_services/user.service";
import { UserRestrictions } from "../_models/userRestriction";
import { UserTab } from "../_models/UserTab";
import { ProjectData } from "src/app/_models/project-data";
import { Pipe, PipeTransform } from "@angular/core";
import { ConfirmationDialogService } from "../test/test-step/confirmation-dialog.service";
// import { MatMenuTrigger } from '@angular/material';
// import { FileSaverService } from 'ngx-filesaver';
import { saveAs } from "file-saver";
import * as fileSaver from "file-saver";
import { SettingService } from "../_services/setting.service";
import { environment } from "../../environments/environment";
import _ from "lodash";
import { MatMenuTrigger } from "@angular/material/menu";
@Component({
  selector: "app-project",
  templateUrl: "./project.component.html",
  styleUrls: ["./project.component.scss"],
})
export class ProjectComponent
  implements OnInit, DoCheck, AfterViewInit, OnChanges, OnDestroy
{
  projectId: any;
  url: string;
  testTreedata: any;
  projectdata: any;
  Parent: any;
  projectdataById: ProjectData;
  public show: boolean = false;
  public buttonName: any = "Show";
  testdata: any;
  testCasedata: any;
  testStepdata: any;
  projectDataForRename: {};
  testTreedataDir: any;
  fileName: string;
  subscription: Subscription;
  subscription3: Subscription;
  messages: any[];
  allProject: any;
  locatorData: any;
  locatoSuitData: any;
  locatorDirData: any;
  locator = false;
  paste = false;
  pasteData: any;
  subscription1: Subscription;
  subscription2: Subscription;
  subscriptionForNewProject: Subscription;
  enableAddition: boolean = false;
  onProject: boolean;
  private options = {
    headers: new HttpHeaders().set("Content-Type", "application/json"),
  };
  onModule: boolean;
  onSuite: boolean;
  onLocator: boolean;
  screenCreateForm: UntypedFormGroup;
  submitted: boolean;
  projectRenameForm: UntypedFormGroup;
  locatorCreateForm: UntypedFormGroup;
  locatorRenameForm: UntypedFormGroup;
  screenRenameForm: UntypedFormGroup;
  moduleRenameForm: UntypedFormGroup;
  testCaseCreateForm: UntypedFormGroup;
  locatorModuleData: any;
  onLocatorSuite: boolean = false;
  suiteData: any;
  locatorModuleName: any;
  onLocatorScreen: boolean = false;
  screenData: any;
  locatorScreenName: any;
  moduleData: any;
  moduleDataName: any;
  suitDataForAdd: any;
  enableManual: boolean = false;
  textData: any;
  testDataForAssociation: any;
  compareName = "";
  disassociationButton: boolean = true;
  searchStringForProject: string;
  searchString: string;
  searchTestData: string;
  manageSuiteData: any;
  activeState: any;
  associationButton: boolean = true;
  disableplus: boolean = true;
  disableminus: boolean = false;
  disableplus2: boolean = true;
  disableminus2: boolean = false;

  selectedProject: string = "";
  selectedModule: string = "";
  selectedTestCaseId: string = "";
  selectedScreenId: string = "";
  executionIteration1 = 1;

  enableCopyPaste: boolean = false;
  enableCutPaste: boolean = false;
  copyId: any;
  enableCopySuite: boolean;
  azureData: Object;
  updateTestModuleForm: UntypedFormGroup;
  suiteDataForUpdate: any;
  dependent: boolean;
  titleName: any;
  description: any;
  testDataFile: any;
  testDataFileName: any;
  suiteIdForImportTestCase: any;
  importedTestCase: any;
  enableSubmit: boolean = false;
  titleForUpdate: any = {};
  seleniumFileName: string;
  enableseleniumButton: boolean;
  seleniumFile: any;
  testId: any;
  hightLightProject: boolean = false;
  highLightTestSuite: boolean = false;
  highLightModule: boolean = false;
  highLightLocatorModule : boolean = false;
  highLightLocatorTestSuite : boolean = false;
  selectedModuleIndex: number;
  selectedLocatorModuleIndex: number;
  searchSuggestions : any = [];
  showSearchResult : boolean = false;
  searchResult : any = [];
  matchedSuggestions : any = [];
  showSuggestion : boolean = false;
  moduleDataCheck: Object;

  constructor(
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService: ToastrService,
    private cookieService: CookieService,
    private elRef : ElementRef,
    private http: HttpClient,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private usermgmt: UserMgmtService,
    private router: Router,
    private setting: SettingService,
    private testService: TestService,
    private confirmationDialogService: ConfirmationDialogService,
    // private _FileSaverService: FileSaverService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.url = environment.baseUrl;
    // this.loadLocator();
    //console.log(this.paste)
    this.subscription = this.project.getDataForPaste().subscribe((data) => {
      if (data) {
        //console.log(data);
        this.pasteData = data["item"];
        this.paste = true;
        if (data.msg == "copy") {
          this.enableCopyPaste = true;
          this.enableCutPaste = false;
        } else if (data.msg == "cut") {
          this.enableCopyPaste = false;
          this.enableCutPaste = true;
        }
      } else {
        // clear messages when empty message received
        this.messages = [];
      }
    });
    this.subscription1 = this.project.getProjectData().subscribe((data) => {
      if (data) {
        //console.log(data);
        this.enableAddition = true;
        // this.refreshPage();
        // this.projectdata = data['projectData'];

        this.getProjectTreeData();

        // this.getAllChildTestDir(data['projectData'].project[0].id)
      }
    });
    this.subscription2 = this.project.getLocators().subscribe((data) => {
      this.loadLocator();
    });
    this.subscription3 = this.project.getLocatorData().subscribe((data) => {
      const projectId = data["Data"];
      //console.log(data);
      this.getAllChildLocatorData(projectId);
    });
  }
  //   @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;

  //   //And call:

  //   @ViewChild('menuBtn1', { read: MatMenuTrigger, static: false}) menuBtn1: MatMenuTrigger;
  // // @ViewChild('contextMenu1', { read: MatMenuTrigger, static: false}) contextMenu1: MatMenuTrigger;
  @ViewChild('cancelProjectRenamemodal', null) cancelProjectRenamemodal: ElementRef;
  @ViewChild('cancelNewScreenmodal', null) cancelNewScreenmodal: ElementRef;
  @ViewChild('cancelmodalforlocatorModule', null) cancelmodalforlocatorModule: ElementRef;
  @ViewChild('cancelrenameForm', null) cancelrenameForm: ElementRef;
  @ViewChild('cancelscreenForm', null) cancelscreenForm: ElementRef;
  @ViewChild('cancelmodalsuite', null) cancelmodalsuite: ElementRef;
  @ViewChild('cancelrenameModuleForm', null) cancelrenameModuleForm: ElementRef;
  @ViewChild('cancelmodalForUpdate', null) cancelmodalForUpdate: ElementRef;
  @ViewChild('cancelImportTestCase', null) cancelImportTestCase: ElementRef;
  @ViewChild('cancelSeleniumDataScreen', null) cancelSeleniumDataScreen: ElementRef;
  @ViewChild(MatMenuTrigger, null)
  contextMenu: MatMenuTrigger;
  @ViewChild(MatMenuTrigger, null)
  contextMenu1: MatMenuTrigger;
  @ViewChild(MatMenuTrigger, null)
  contextMenu2: MatMenuTrigger;

  contextMenuPosition = { x: "0px", y: "0px" };
  contextMenu1Position = { x: "0px", y: "0px" };
  contextMenu2Position = { x: "0px", y: "0px" };
  // getTestData(){
  //   this.testCase.getTestData().subscribe(
  //     (data) => {
  //       this.testdata = data[''];
  //     }
  //   );
  // }
  // getTestCaseData(){
  //   this.testCase.getTestSuiteData().subscribe(
  //     (data) => {
  //       this.testCasedata = data;
  //       //console.log(" testCaseData", this.testCasedata);
  //     }
  //   );
  // }

  getProjectTreeData() {
    this.project.getAllProjects().subscribe((data) => {
      this.projectdata = data["project"];
      // TreeData = this.projectdata;
      // this.dataSource = this.projectdata;
      //console.log('[project]', this.projectdata);
    });
  }

  getAllChildLocatorData(projectId: any) {
    //console.log(this.projectdata);
    this.locatorData = this.project
      .getAllChildLocatorDir(projectId)
      .subscribe((data) => {
        this.locatorData = data;
      
       
        //console.log(this.locatorData);
        this.locatoSuitData = data["locatorSuite"];
        this.locatorDirData = data["locatorDirSuite"];
        if( Object.keys(data).length === 0 ){
          console.log('----empty');
          console.log(this.projectdata);
          this.projectdata[0].locatoSuitData=[];
          console.log( this.projectdata[0].testTreedata[0].items[0].title);
          // return;
          // this.getProjectTreeData();
        }
        else if( this.locatoSuitData==undefined){
          this.projectdata[0].locatoSuitData=[];
          // return;
        }
        else if( this.locatorDirData==undefined){
          this.projectdata[0].locatoSuitData=[];
          // return;
        }
        if(this.locatoSuitData && this.locatorDirData){
        const locatorModule = [];
        //console.log('locatorDirData>>', this.locatorDirData);
        //console.log('lolSuitData', this.locatoSuitData);
        if (this.locatorDirData) {
          for (let i = 0; i < this.locatorDirData.length; i++) {
            //  //console.log(this.locatorDirData[i].id);
            for (let j = 0; j < this.locatoSuitData.length; j++) {
              if (this.locatoSuitData[j].parentLocatorId) {
                if (
                  this.locatorDirData[i].id ==
                  this.locatoSuitData[j].parentLocatorId
                )
                  this.locatoSuitData[j].obj = this.locatorDirData[i].name;
                locatorModule.push(this.locatoSuitData[j]);
              }
            }
          }
        }

        //console.log(locatorModule);
        const key = "id";
        const unique = [
          ...new Map(locatorModule.map((item) => [item[key], item])).values(),
        ];
        //console.log(unique);
        //console.log('locatorDirData>>', this.locatorDirData);
        //   this.projectdata = this.projectdata.map(p => ({ ...p, ...this.locatoSuitData.find(testData => testData.projectId === p.id) }));
        //  //console.log(this.projectdata);

        const projectTestId =
          this.locatoSuitData[0] && this.locatoSuitData[0].projectId;
        const moduleData1 = []; // [{name: "a", items: [{}, {}]}, {}]
        const b = {}; // {a: true}
        if (this.locatorDirData) {
          this.locatorDirData.forEach((element) => {
            b[element.id] = [];
          });
        }
        this.locatoSuitData.forEach(function (d) {
          if (b[d.parentLocatorId]) {
            b[d.parentLocatorId].push(d);
          } else {
            b[d.parentLocatorId] = [];
            b[d.parentLocatorId].push(d);
          }
        });
        Object.entries(b).forEach(([key, value]) => {
          moduleData1.push({ name: key, items: value });
        });
        if (this.locatorDirData) {
          moduleData1.forEach((data) => {
            this.locatorDirData.forEach((element) => {
              if (data.name == element.id) {
                data["value"] = element.name;
              }
            });
          });
        }

        this.projectdata.forEach((element) => {
          if (element.locatoSuitData) {
            element.locatoSuitData.forEach((data) => {
              if (data.expand) {
                moduleData1.forEach((value) => {
                  if (value.name == data.name) {
                    value["expand"] = data.expand;
                  }
                });
              }
            });
          }
        });

        //console.log("moduleData1 : ", moduleData1);

        this.projectdata = this.projectdata.map((p) => ({
          ...p,
          locatoSuitData: p.id === projectTestId ? moduleData1 : [],
        }));
        //console.log('after', this.projectdata);

        console.log(this.projectdata);
        let obj = JSON.parse(localStorage.getItem("selectedProject"));
        if (obj != null) {
          this.projectdata.forEach((element, i) => {
            if (element.id == obj.projectId) {
              if (element.expand == undefined) {
                element.expand = true;
              }
              if (
                obj.moduleName != "undefined" &&
                obj.moduleName != undefined
              ) {
                if (element.locatoSuitData.length > 0) {
                  element.locatoSuitData.forEach((value) => {
                    if (value.name == this.selectedModule) {
                      value.expand = true;
                    }
                  });
                }
              }
            }
          });
        }

      }
     
      });
  }

  sendId(projectId: any) {
    let obj = JSON.parse(localStorage.getItem("selectedProject"));
    obj["projectId"] = projectId;

    localStorage.setItem("selectedProject", JSON.stringify(obj));
    this.project.sendMessage(projectId);
    this.visibleIndex = -1;
    this.projectId = projectId;
    this.enableAddition = false;
    //console.log(this.projectdata, this.projectId);
    this.projectdata.forEach((element) => {
      if (element.id === this.projectId) {
        if (element.expand) {
          element.expand = false;
        } else {
          element.expand = true;
        }
      } else {
        element.expand = false;
      }
    });
    // this.disableplus = false;
    // this.disableminus = true;
  }

  sendIdForLocator(projectId: any, pathData) {
    let obj = JSON.parse(localStorage.getItem("selectedProject"));
    obj["projectId"] = projectId;

    localStorage.setItem("selectedProject", JSON.stringify(obj));
    this.project.sendMessage(projectId);
    // this.visibleIndex = -1;
    this.projectId = projectId;
    this.enableAddition = false;
    //console.log(this.projectdata, this.projectId, pathData);
    this.projectdata.forEach((element) => {
      if (element.id == projectId) {
        if (element.locatoSuitData) {
          element.locatoSuitData.forEach((data) => {
            if (data.name == pathData.name) {
              //console.log(data.expand);
              if (data.expand == true) {
                data.expand = false;
              } else {
                data.expand = true;
              }
            }
            // else
            // {
            //   data.expand = false;
            // }
          });
        }
      }
    });
  }

  getProjectsById(projectId: any) {
    this.projectId = projectId;
    var respo = this.project
      .getProjectById(this.projectId)
      .subscribe((data: ProjectData) => {
        this.projectdataById = data;
        this.project.setProjectDetails(data);
      });
    // //console.log( '>>>'+ JSON.stringify(this.projectdataById));
  }
  loadLocator() {
    this.locator = true;
    this.projectdata.forEach((element) => {
      element.expand = false;
    });

    let selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    selectedProject.projectTree = false;
    localStorage.setItem("selectedProject", JSON.stringify(selectedProject));

    this.hightLightProject = false;
    this.highLightTestSuite = false;
    this.highLightModule = false;
    this.highLightLocatorModule = false;
    this.highLightLocatorTestSuite = false;
    this.project.isModuleSelected.next(false);
    this.project.isLocatorModuleSelected.next(false);
    this.project.isTestSuiteSelected.next(false);
    this.project.isLocatorTestSuiteSelected.next(false)
  }

  loadproject() {
    this.locator = false;
    this.projectdata.forEach((element) => {
      element.expand = false;
    });

    let selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    selectedProject.projectTree = true;
    localStorage.setItem("selectedProject", JSON.stringify(selectedProject));

    this.hightLightProject = false;
    this.highLightTestSuite = false;
    this.highLightModule = false;
    this.highLightLocatorModule = false;
    this.highLightLocatorTestSuite = false;
    this.project.isModuleSelected.next(false);
    this.project.isLocatorModuleSelected.next(false);
    this.project.isTestSuiteSelected.next(false);
    this.project.isLocatorTestSuiteSelected.next(false)
  }

  getAllChildTestDir(projectId) {
    //console.log('before', this.projectdata);

    this.http
      .get(this.url + "/HuLoopRest/huloop/" + "test/all/" + projectId)
      .subscribe((data) => {
        console.log(data);
       this.moduleDataCheck = data;
        if( Object.keys(this.moduleDataCheck).length === 0){
          console.log('----empty');
          console.log(this.projectdata);
          console.log( this.projectdata[0].testTreedata[0].items[0].title);
          this.getProjectTreeData();
          // this.projectdata[0].testTreedata[0].item[0].title='';

          // this.reloadComponent();
          this.router.navigate([
            "/report/project-report/" + this.projectId,
          ]);
         }
        else if( data["testSuiteFileData"] == undefined){
          console.log('----empty suite');
          console.log(this.projectdata);
          console.log( this.projectdata[0].testTreedata[0].items[0].title);
          this.getProjectTreeData();
          // this.projectdata[0].testTreedata[0].item[0].title='';

          // this.reloadComponent();
          this.router.navigate([
            "/report/project-report/" + this.projectId,
          ]);
         }
        else if( Object.keys(data).length > 0){
         
          // this.testTreedata[0]['projectId']=' ';
         
        this.testTreedata = data["testSuiteFileData"];

        this.testTreedataDir = data["testSuiteDirData"];
        //console.log('Dir Data', this.testTreedataDir)
        //  this.Parent = this.testTreedata[0].parentTestDataId;
        //  //console.log( this.Parent);
        //  //console.log( '[TestTreeData]', this.testTreedata);
        //console.log("idcheck", this.testTreedata);
        
        const projectTestId =
          this.testTreedata[0] && this.testTreedata[0].projectId;

        //console.log("clicked >", projectTestId);
        // const data = []; //  data from API

        // const moduleTestData = {};

        // this.testTreedata.forEach(function (d) {
        //   if(moduleTestData[d.path]) {
        //     moduleTestData[d.path].push(d)
        //   } else {
        //     moduleTestData[d.path] = [];
        //   }
        // });

        // //console.log(moduleTestData);

        //  //console.log('hello');
        const moduleData = []; // [{name: "a", items: [{}, {}]}, {}]
        const b = {}; // {a: true}
        this.testTreedata.forEach(function (d) {
          if (b[d.path]) {
            b[d.path].push(d);
          } else {
            b[d.path] = [];
            b[d.path].push(d);
          }
        });
        // this.testTreedataDir.forEach(function (d) {
        //   if (b[d.path]) {
        //     b[d.path].push(d);
        //   } else {
        //     b[d.path] = [];
        //     b[d.path].push(d);
        //   }
        // });
        Object.entries(b).forEach(([key, value]) => {
          moduleData.push({ name: key, items: value });
        });

        this.projectdata.forEach((element) => {
          if (element.testTreedata) {
            element.testTreedata.forEach((data) => {
              if (data.expand) {
                moduleData.forEach((value) => {
                  if (value.name == data.name) {
                    value["expand"] = data.expand;
                  }
                });
              }
            });
          }
        });
        //console.log(moduleData);
        //  //console.log('hello end');
        //  this.projectdata = moduleData;
        //  this.projectdata = this.projectdata.map(p => ({ ...p, ...this.testTreedata.find(testData => testData.projectId === p.id) }));

        //console.log('before', this.projectdata);
        this.projectdata = this.projectdata.map((p) => ({
          ...p,
          testTreedata: p.id === projectTestId ? moduleData : [],
        }));

        //console.log('after', this.projectdata);
        // if(this.projectdata.testTreedata){
        //   this.disableminus = true;
        //   this.disableplus = false;
        // }
        // else{
        //   this.disableminus = false;
        //   this.disableplus = true;
        // }
        //  //console.log('after',this.projectdata);
        //  var dataCheck = this.projectdata.filter((f)=>f.id==projectId);
        //  //console.log(dataCheck);
        //   if(dataCheck[0].testTreedata.length>0){
        //     this.disableminus=true;
        //     this.disableplus = false;
        //   }
        //  //console.log('tree>',dataCheck[0].testTreedata)
        //console.log('minus', this.disableminus);
        //console.log('plus', this.disableplus);

        console.log(this.projectdata);

        let obj = JSON.parse(localStorage.getItem("selectedProject"));
        if (obj != null) {
          this.projectdata.forEach((element, i) => {
            if (element.id == obj.projectId) {
              if (element.expand == undefined) {
                element["expand"] = true;
              }

              if (obj.moduleName != ",") {
                if (element.testTreedata.length > 0) {
                  element.testTreedata.forEach((value) => {
                    if (value.name == this.selectedModule) {
                      value.expand = true;
                    }
                  });
                }
              }
            }
          });
        }
      }
      });
  }

  visibleIndex = -1;
  showSubItem(ind, treedId, pathName) {
    //console.log(this.projectdata, treedId, pathName);
    this.projectdata.forEach((element) => {
      if (element.id === treedId) {
        element.testTreedata.forEach((data) => {
          if (data.name == pathName) {
            if (data.expand) {
              data.expand = false;
            } else {
              data.expand = true;
            }
          }
          // else
          // {
          //   data.expand = false;
          // }
        });
      } else {
        element.testTreedata.forEach((data) => {
          data.expand = false;
        });
      }
    });
    // if(this.disableplus2){
    //   this.disableplus2 = false;}
    //   else {
    //   this.disableplus2 = true;}

    //   if(this.disableminus2){
    //   this.disableminus2 = false;}
    //   else {
    //   this.disableminus2 = true; }

    // if (this.visibleIndex === ind) {
    //   this.visibleIndex = -1;
    // } else {
    //   this.visibleIndex = ind;
    // }
  }

  toggleChildren(i, id) {
    //console.log('>>>', i, id);
  }
  // getTestStepData(){
  //   this.project.getTestCaseData(this.projectId,testId).subscribe(
  //     (data) => {
  //       this.testStepdata = data;
  //       //console.log("TestStepData",this.testStepdata);
  //     }
  //   );
  // }
  ngOnInit() {
    // this.getTestStepData();
    // this.getTestCaseData();
    // this.getTestData();
    //console.log('******************************************************************oninit');

    this.initAllForms();
    this.project.getAllProjects().subscribe((data) => {
      this.projectdata = data["project"];

      this.project.subjectforProjectData.subscribe((res) => {
        setTimeout(() => {
          //console.log('parent', this.projectId);
          this.getAllChildTestDir(this.projectId);
        }, 2000);
      });

      // this.projectdata.forEach(element => {
      //     element.expand = false;
      // });
    });

    let selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    console.log(selectedProject);

    this.project.getTestSuiteData().subscribe((response) => {
      console.log(this.projectdata);
      //console.log(response);
      this.selectedProject = response.projectId;
      this.selectedTestCaseId = response.suiteId;

      selectedProject["projectId"] = response.projectId;
      this.projectId = response.projectId;
      selectedProject["testCaseId"] = response.suiteId;
      if (response.suiteName) {
        this.selectedModule = response.moduleName;
        selectedProject["moduleName"] = response.moduleName;
      } else {
        this.selectedModule = ",";
        selectedProject["moduleName"] = ",";
      }

      localStorage.setItem("selectedProject", JSON.stringify(selectedProject));
    });

    console.log(selectedProject);

    if (selectedProject != null) {
      this.project.sendMessage(selectedProject.projectId);
      if (selectedProject.projectName != "") {
        this.highLightTestSuite = false;
        this.hightLightProject = true;
        this.highLightModule = false;
        this.highLightLocatorModule = false;
        this.highLightLocatorTestSuite = false;

        this.project.isModuleSelected.next(false);
        this.project.isLocatorModuleSelected.next(false);
        this.project.isTestSuiteSelected.next(false);
        this.project.isLocatorTestSuiteSelected.next(false)
        this.selectedProject = selectedProject.projectId;
        this.projectId = selectedProject.projectId;
        this.locator = !selectedProject.projectTree;

        if (selectedProject.testCaseId != "") {
          this.highLightTestSuite = true;
          this.highLightLocatorTestSuite = true;
          this.hightLightProject = false;
          this.highLightModule = false;
          this.project.isModuleSelected.next(false);
          this.project.isLocatorModuleSelected.next(false);
          this.project.isTestSuiteSelected.next(true);
          this.project.isLocatorTestSuiteSelected.next(true)
          this.highLightLocatorModule = false;

          this.selectedModule = selectedProject.moduleName;
          this.selectedTestCaseId = selectedProject.testCaseId;
        }

        if (this.locator) {
          this.selectedScreenId = selectedProject.testCaseId;
        }

        setTimeout(() => {
          this.getAllChildTestDir(selectedProject.projectId);
          this.getAllChildLocatorData(selectedProject.projectId);
        }, 1000);
      }
    } else {
      let selectedProject = {
        projectId: "",
        projectName: "",
        moduleName: "",
        testCaseId: "",
        projectTree: true,
      };

      localStorage.setItem("selectedProject", JSON.stringify(selectedProject));
    }

    this.project.treeView.subscribe((res) => {
      this.locator = res === "locator" ? true : false;
    });

    this.project.loadSuggestion.subscribe((res)=>
    {
      this.project.getSearchSuggestions().subscribe((res)=>
      {
        this.searchSuggestions = res['suggestion'];
      })
    })

  }

  initAllForms() {
    this.screenCreateForm = this.formBuilder.group({
      screenName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });
    this.locatorCreateForm = this.formBuilder.group({
      locatorName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });
    this.locatorRenameForm = this.formBuilder.group({
      locatorName: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });
    this.screenRenameForm = this.formBuilder.group({
      screenName: [
        this.locatorScreenName,
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });
    this.moduleRenameForm = this.formBuilder.group({
      moduleName: [
        this.moduleDataName,
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });
    this.projectRenameForm = this.formBuilder.group({
      rename: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
    });

    this.testCaseCreateForm = this.formBuilder.group({
      title: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
      testCaseId: [],
      dataLabels: [],
      comment: [],
      executionIteration: ["1", Validators.required],
    });
    this.updateTestModuleForm = this.formBuilder.group({
      name: [
        "",
        [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      ],
      comment: [""],
    });
  }

  get f() {
    return this.testCaseCreateForm.controls;
  }
  get g() {
    return this.updateTestModuleForm.controls;
  }
  enableManualTestCase() {
    this.enableManual = true;
  }
  onCreateTestCase() {
    this.submitted = true;
    if (this.testCaseCreateForm.invalid) {
      return;
    }
    var objFormval = this.testCaseCreateForm.value;
    //console.log(this.enableManual);
    //console.log(objFormval);
    if (this.enableManual) {
      //console.log(this.enableManual);
      objFormval.testCaseType = "MANUAL";
    }
    //console.log(objFormval);

    this.testService
      .addTestCase(this.projectId, this.suitDataForAdd.id, objFormval)
      .subscribe((data) => {
        this.project.sendUpdateData(data);
        this.enableManual = false;

        this.cancelmodalsuite.nativeElement.click();
        this.testCaseCreateForm = this.formBuilder.group({
          title: [
            "",
            [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
          ],
          testCaseId: [],
          dataLabels: [],
          comment: [],
          executionIteration: ["1", Validators.required],
        });
        // this.testCaseCreateForm.reset();
        this.executionIteration1 = 1;
        this.toastrService.clear();
        this.toastrService.success(" New Task Added successfully");
        this.project.loadSuggestion.next(true);
      });
  }

  onCreateScreen() {
    //console.log("inside create screen");
    this.submitted = true;
    if (this.screenCreateForm.invalid) {
      return;
    }
    var objFormval = this.screenCreateForm.value;
    if (!/^[^:|*?<>/\\"]+$/.test(objFormval.screenName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Locator screen Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }

    if (!this.onLocatorSuite) {
      //console.log('from parent')
      var Objval = {
        name: objFormval.screenName,
        projectId: this.projectId,
      };
      this.project.addScreen(Objval).subscribe((data) => {
        if (data) {
          this.cancelNewScreenmodal.nativeElement.click(); //;
          this.toastrService.clear();
          this.toastrService.success(" New Screen Added successfully");
          // //console.log("Locator data",data);
          // this.refreshPage();
          this.getAllChildLocatorData(this.projectId);
        }
      });
    } // var cancelObj = this.cancelmodal;
    //console.log(Objval);
    if (this.onLocatorSuite) {
      console.log('for child', this.suiteData)
      var ObjvalForDefault = {
        name: objFormval.screenName,
        projectId: this.projectId,
        parentLocatorId: this.suiteData.name,
      };
      this.project.addScreen(ObjvalForDefault).subscribe((data) => {
        //console.log("after getting response");

        this.cancelNewScreenmodal.nativeElement.click();
        this.toastrService.clear();
        this.toastrService.success(" New Screen Added successfully");

        this.getAllChildLocatorData(this.projectId);
      });
    }
  }

  onCreateLocators() {
    this.submitted = true;
    if (this.locatorCreateForm.invalid) {
      return;
    }
    var objFormval = this.locatorCreateForm.value;

    if (!/^[^:|*?<>/\\"]+$/.test(objFormval.locatorName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Locator Module Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }

    var Objval = {
      name: objFormval.locatorName,
      projectId: this.projectId,
    };
    //console.log(Objval);
    // var cancelObj = this.cancelmodal;
    this.project.addLocator(Objval).subscribe((data) => {
      if (data) {
        this.locatorModuleData = data;
        //console.log(this.locatorModuleData.id)
        var ObjvalForDefault = {
          name: objFormval.locatorName + "Screen",
          projectId: this.projectId,
          parentLocatorId: this.locatorModuleData.id,
        };
        //console.log(Objval);
        // var cancelObj = this.cancelmodal;
        this.project.addScreen(ObjvalForDefault).subscribe((data) => {
          if (data) {
            this.cancelmodalforlocatorModule.nativeElement.click();
            this.getAllChildLocatorData(this.projectId);
            this.initAllForms();
            this.toastrService.clear();
            this.toastrService.success(
              " New locator process group Added successfully"
            );
            //console.log("Locator data", data);
          }
        });
      }
    });
  }
  onRenameLocatorModule() {
    this.submitted = true;
    if (this.locatorRenameForm.invalid) {
      return;
    }

    var objFormval = this.locatorRenameForm.value;
    //console.log(objFormval);
    if (!/^[^:|*?<>/\\"]+$/.test(objFormval.locatorName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Locator Module Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }
    var Objval = {
      name: objFormval.locatorName,
      id: this.suiteData.name,
      projectId: this.projectId,
    };
    //console.log(Objval);
    this.project.editLocatorDirSuiteTitle(Objval).subscribe((data) => {
      this.toastrService.clear();
      this.toastrService.success("Title name renamed Successfully.");
      this.getAllChildLocatorData(this.projectId);
      this.cancelrenameForm.nativeElement.click();
    });
  }

  onRenameScreen() {
    this.submitted = true;
    if (this.screenRenameForm.invalid) {
      return;
    }

    var objFormval = this.screenRenameForm.value;
    if (this.screenData["parentLocatorId"]) {
      this.titleForUpdate = {
        name: objFormval.screenName,
        id: this.screenData.id,
        projectId: this.projectId,
        parentLocatorId: this.screenData.parentLocatorId,
      };
    } else {
      this.titleForUpdate = {
        name: objFormval.screenName,
        id: this.screenData.id,
        projectId: this.projectId,
      };
    }

    if (!/^[^:|*?<>/\\"]+$/.test(objFormval.screenName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Screen Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }
    this.setting.editLocatorSuitTitle(this.titleForUpdate).subscribe((data) => {
      this.toastrService.clear();
      this.toastrService.success("Screen updated succesfully");
      this.cancelscreenForm.nativeElement.click();
      this.getAllChildLocatorData(this.projectId);
      this.submitted = false;
      // this.enableSubmit = false;
    });
  }

  onRenameModule() {
    this.submitted = true;
    if (this.moduleRenameForm.invalid) {
      return;
    }

    var objFormval = this.moduleRenameForm.value;

    const title = {
      title: objFormval.moduleName,
      id: this.moduleData.items[0].parentTestDataId,
      projectId: this.projectId,
    };
    if (!/^[^:|*?<>/\\"]+$/.test(objFormval.moduleName)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Module Name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }
    this.project.editTestDir(title).subscribe((data) => {
      this.toastrService.clear();
      this.toastrService.success("Title updated succesfully");
      this.cancelrenameModuleForm.nativeElement.click();
      this.getAllChildTestDir(this.projectId);
      this.initAllForms();
      // this.enableSubmit = false;
    });
  }
  ngDoCheck() {}
  ngOnChanges() {}

  renameProject(id, title) {
    this.projectDataForRename = {
      projectName: title,
      id: id,
    };

    this.projectRenameForm.patchValue({
      rename: title,
    });
  }

  onRenameProject() {
    this.submitted = true;
    if (this.projectRenameForm.invalid) {
      return;
    }
    var objFormval = this.projectRenameForm.value;

    const ValueForRename = {
      projectName: objFormval.rename,
      id: this.projectDataForRename["id"],
    };

    if (!/^[^:|*?<>/\\"]+$/.test(ValueForRename.projectName)) {
      this.toastrService.clear();
      this.toastrService.warning("Project Name is not Valid");
      return;
    }

    this.http
      .put(this.url + "/HuLoopRest/huloop/project", ValueForRename)
      .subscribe((data) => {
        if (data) {
          // this.testCassedata= data;
          //console.log("projectData", data);
          this.cancelProjectRenamemodal.nativeElement.click();
          this.toastrService.success("Project renamed successfully");
          this.project.loadSuggestion.next(true);
          this.getProjectTreeData();
        }
      });
  }

  renameModule(item) {
    //console.log(item);
    //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/editTestDir
  }

  removeProject(id, title) {
    this.confirmationDialogService
      .openConfirmDialog("Are you sure you want to delete " + title + " ?")
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.project.deleteProjectById(id).subscribe((data) => {
            this.getProjectTreeData();
            this.toastrService.clear();
            this.toastrService.success("Project deleted successfully");
            this.router.navigate(["/project/home"]);
            this.project.loadSuggestion.next(true);
            this.project.sendMessage(undefined);
          });
        }
      });
  }

  removeLocatorModule() {
    this.confirmationDialogService
      .openConfirmDialog(
        "Are you sure you want to delete " + this.locatorModuleName + " ?"
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.project
            .deleteLocator(this.projectId, this.suiteData.name)
            .subscribe((data) => {
              this.getAllChildLocatorData(this.projectId);
              this.toastrService.clear();
              this.toastrService.success("Process Group deleted successfully");
              this.router.navigate([
                "/report/project-report/" + this.projectId,
              ]);
              // this.router.navigate(['/project'])
            });
        }
      });
  }

  hightLightModule(module, index) {
    this.selectedModuleIndex = index;
    this.highLightTestSuite = false;
    this.hightLightProject = false;
    this.highLightModule = true;
    this.highLightLocatorTestSuite = false;
    this.project.isModuleSelected.next(true);
    let obj = {projectId : this.projectId, moduleData :  module};
    this.project.selectedModuleData.next(obj);
    this.project.isTestSuiteSelected.next(false);
    this.project.isLocatorTestSuiteSelected.next(false)
  }

  hightLightLocatorModule(module, index) {
    this.selectedLocatorModuleIndex = index;
    this.highLightTestSuite = false;
    this.hightLightProject = false;
    this.highLightLocatorTestSuite = false;
    this.highLightLocatorModule = true;
    this.project.isLocatorModuleSelected.next(true);
    let obj = {projectId : this.projectId, moduleData :  module};
    this.project.selectedLocatorModuleData.next(obj);
    this.project.isTestSuiteSelected.next(false);
    this.project.isLocatorTestSuiteSelected.next(false)
  }

  removeScreen() {
    this.confirmationDialogService
      .openConfirmDialog(
        "Are you sure you want to delete " + this.locatorScreenName + " ?"
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.setting
            .deleteLocator(this.projectId, this.screenData.id)
            .subscribe((data) => {
              this.getAllChildLocatorData(this.projectId);
              this.toastrService.clear();
              this.toastrService.success("Screen deleted succesfully");
              this.router.navigate([
                "/report/project-report/" + this.projectId,
              ]);
              // this.router.navigate(['/project'])
            });
        }
      });
  }

  ngAfterViewInit() {
  }

  addModule(pathData) {
    //console.log(pathData);
    this.confirmationDialogService
      .openAddModulePopUp(pathData)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.getAllChildTestDir(this.projectId);
          this.project.loadSuggestion.next(true);
          // this.getAllChildTestDir(pathData.projectId)

          //  this.refreshPage();
        }
      });
  }

  addModulefromProject(item) {
    //console.log('addtestSuitfromProject')
    this.confirmationDialogService
      .openAddtestSuitPopUp(item, "Add")
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.getAllChildTestDir(this.projectId);
          this.project.loadSuggestion.next(true);
          //console.log('Afdd', this.projectId);
        }
      });
    //console.log('AddModule')
  }

  addParentModule(parentModule) {
    //console.log(parentModule)
    this.confirmationDialogService
      .openParentModulePopUp(parentModule)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          setTimeout(() => {
            //console.log('parent', this.projectId);
            this.getAllChildTestDir(this.projectId);
            // this.toastrService.clear();
            // this.toastrService.success( ' Module Added successfully');
          }, 2000);
        }
      });
  }

  refresh(item) {
    this.getAllChildTestDir(item);
    this.getAllChildLocatorData(item);
    //console.log(this.projectdata);

    this.projectdata.forEach((element) => {
      if (element.id === item) {
        element.testTreedata.forEach((data) => {
          if (data.expand) {
            data.expand = false;
          }
        });
      }
    });

    this.projectdata.forEach((element) => {
      if (element.id === item) {
        element.locatoSuitData.forEach((data) => {
          if (data.expand) {
            data.expand = false;
          }
        });
      }
    });
  }

  removeModule(pathdata) {
    this.confirmationDialogService
      .openConfirmDialog(
        "Are you sure to delete " + pathdata.name.replaceAll(",", "") + " ?"
      )
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.http
            .delete(
              this.url +
                "/HuLoopRest/huloop/test" +
                "/" +
                pathdata.items[0].projectId +
                "/" +
                pathdata.items[0].parentTestDataId
            )
            .subscribe((data) => {
              this.getAllChildTestDir(this.projectId);
              this.toastrService.clear();
              this.toastrService.success("Process Group deleted successfully");
              this.project.loadSuggestion.next(true);
              this.router.navigate([
                "/report/project-report/" + this.projectId,
              ]);
              // this.refreshPage();
            });
        }
      });
  }

  removeSuite(pathdata) {
    //console.log(pathdata)
    this.confirmationDialogService
      .openConfirmDialog("Are you sure to delete " + pathdata.title + " ?")
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          console.log(pathdata)
          this.project
            .deleteTestSuite(this.projectId, pathdata.id)
            .subscribe((data) => {
              this.getAllChildTestDir(this.projectId);
              this.toastrService.clear();
              this.toastrService.success("Process deleted successfully");
              this.project.loadSuggestion.next(true);
              this.router.navigate([
                "/report/project-report/" + this.projectId,
              ]);
              // this.refreshPage();
            });
        }
      });
  }

  onContextMenu(event: MouseEvent, treedata) {
    event.preventDefault();
    this.onProject = true;
    this.onModule = false;
    this.onSuite = false;
    this.onLocator = false;
    this.onLocatorSuite = false;
    this.onLocatorScreen = false;
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: treedata };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
    //console.log(treedata, 'onContext', this.contextMenu.menuData);
  }

  onContextModuleMenu(event: MouseEvent, pathData) {
    event.preventDefault();
    this.onProject = false;
    this.onModule = true;
    this.onSuite = false;
    this.onLocator = false;
    this.onLocatorSuite = false;
    this.onLocatorScreen = false;

    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: pathData };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
    this.moduleData = pathData;
    this.moduleDataName = this.moduleData.name
      .replace(",", "")
      .replaceAll(",", "");
    //console.log(pathData, 'onContextModule', this.contextMenu1.menuData);
  }
  onContextSuiteMenu(event: MouseEvent, suiteData) {
    event.preventDefault();
    this.onProject = false;
    this.onModule = false;
    this.onSuite = true;
    this.onLocator = false;
    this.onLocatorSuite = false;
    this.onLocatorScreen = false;
    //console.log(suiteData, 'onContextSuite');
    //console.log(this.contextMenu1, 'cm');
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: suiteData };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
    this.suitDataForAdd = suiteData;
    //console.log(suiteData, 'onContexSuite', this.suitDataForAdd);
  }

  onContextMenuforLocator(event: MouseEvent, treedata) {
    event.preventDefault();
    this.onProject = false;
    this.onModule = false;
    this.onSuite = false;
    this.onLocator = true;
    this.onLocatorSuite = false;
    this.onLocatorScreen = false;
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: treedata };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
    //console.log(treedata, 'onContextLocator', this.contextMenu.menuData);
  }

  onContextLocatorSuiteMenu(event: MouseEvent, suiteData) {
    event.preventDefault();
    this.onProject = false;
    this.onModule = false;
    this.onSuite = false;
    this.onLocator = false;
    this.onLocatorSuite = true;
    this.onLocatorScreen = false;
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: suiteData };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
    this.suiteData = suiteData;
    //console.log(this.suiteData.name)
    this.locatorModuleName = this.suiteData.items[0].obj;
    this.locatorRenameForm.patchValue({
      locatorName: this.locatorModuleName,
    });
    //console.log(suiteData, 'onContextLocator', this.contextMenu.menuData);
  }

  onContextLocatorScreenMenu(event: MouseEvent, screenData) {
    event.preventDefault();
    this.onProject = false;
    this.onModule = false;
    this.onSuite = false;
    this.onLocator = false;
    this.onLocatorSuite = false;
    this.onLocatorScreen = true;
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: screenData };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
    this.screenData = screenData;
    // //console.log(this.screenData.name)
    this.locatorScreenName = this.screenData.name;
    //console.log(screenData, 'onContextLocator', this.contextMenu.menuData);
  }
  runManagement(id) {
    this.router.navigate(["/run-management/" + id]);
  }
  dataManagement(id) {
    this.router.navigate(["/data-management/" + id]);
  }
  localData(id) {
    this.router.navigate(["/manage-localization/" + id]);
  }
  importData(id) {
    this.router.navigate(["/data-management/" + id]);
  }
  javascriptData(id) {
    this.router.navigate(["/manage-javascript/" + id]);
  }
  bugData(id) {
    this.router.navigate(["/manage-bug/" + id]);
  }
  autoItData(id) {
    this.router.navigate(["/manage-auto-it/" + id]);
  }
  pythonData(id) {
    this.router.navigate(["/manage-python-script/" + id]);
  }
  sqlData(id) {
    this.router.navigate(["/manage-sql-script/" + id]);
  }
  exportProject(id) {}

  prjExportFile(projectId, Pname) {
    //console.log(Pname);
    this.fileName = Pname + ".zip";
    //console.log(this.fileName);

    var uploadUrl =
      this.url + "/HuLoopRest/huloop/projectExport/export/" + projectId;
    this.toastrService.clear();
    this.toastrService.success(
      'Exporting project...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>',
      null,
      {
        extendedTimeOut: 0,
        timeOut: 0,
        enableHtml: true,
      }
    );
    this.http
      .post(uploadUrl, null, {
        headers: {
          accept: "application/octet-stream",
        },
        responseType: "arraybuffer",
      })
      .subscribe((response) => {
        // var fileName = headers('Content-Disposition').split(";")[1].trim().split("=")[1];
        // fileName = fileName.replace(/"/g, '');
        var data = new Blob([response], {
          type: "application/octet-stream",
        });
        saveAs(data, this.fileName);
        this.toastrService.clear();
        this.toastrService.success("Project exported successfully");
      });
  }

  prjInformationExportFile(projectId) {
    var uploadUrl =
      this.url + "/HuLoopRest/huloop/projectExport/exportInfo/" + projectId;
    this.toastrService.clear();
    this.toastrService.success(
      'Preparing project information...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>',
      null,
      {
        extendedTimeOut: 0,
        timeOut: 0,
        enableHtml: true,
      }
    );
    this.http
      .post(uploadUrl, null, {
        headers: {
          accept: "application/octet-stream",
        },
        responseType: "arraybuffer",
      })
      .subscribe((response) => {
        //                            var fileName = headers('Content-Disposition').split(";")[1].trim().split("=")[1];
        //                            fileName = fileName.replace(/"/g, '');
        //                            var data = new Blob([response], {
        //                                type: 'application/octet-stream'
        //                            });
        //                            FileSaver.saveAs(data, fileName);
        this.toastrService.clear();
        this.toastrService.success("you will receive email shortly");
      });
  }

  sendMessage(id): void {
    // send message to subscribers via observable subject

    let obj = JSON.parse(localStorage.getItem("selectedProject"));
    obj["projectId"] = id;

    localStorage.setItem("selectedProject", JSON.stringify(obj));
    this.project.sendMessage(id);
  }

  clearMessages(): void {
    // clear messages
    this.project.clearMessages();
  }

  pasteTestCase(pid, testId) {
    if (!this.pasteData) {
      this.toastrService.clear();
      this.toastrService.warning("Please copy a task before pasting");
      return;
    }
    if (this.pasteData) {
      if (this.pasteData.projectId != pid) {
        this.toastrService.clear();
        this.toastrService.warning("can not paste into another project");
        return;
      } else if (this.pasteData.projectId == pid) {
        //console.log(this.pasteData);
        const obj = {
          id: this.pasteData.id,
        };

        this.project
          .copyTestCase(this.pasteData.projectId, testId, obj.id, this.options)
          .subscribe((data) => {
            //console.log(data);

            this.getAllChildTestDir(this.projectId);
            this.project.sendTestData(data);
            this.enableCopyPaste = false;
            this.toastrService.clear();
            this.toastrService.success("Task pasted successfully");
            // window.location.reload(); // add by surendra
          });
        // this.project.clearMessages();
      }
    }
  }

  moveTestCase(pid, testId) {
    //console.log(testId);
    //console.log(this.pasteData);
    const obj = {
      id: this.pasteData.id,
    };
    this.project
      .moveTestCase(
        this.pasteData.projectId,
        this.pasteData.parentTestDataId,
        testId,
        obj.id
      )
      .subscribe((data) => {
        //console.log(data);
        this.getAllChildTestDir(this.projectId);
        this.project.sendTestData(data);
        this.enableCutPaste = false;
        this.toastrService.clear();
        this.toastrService.success("Task pasted successfully");
        // window.location.reload(); // add by surendra

        //  this.getAllChildTestDir(this.projectId);
      });
  }

  //Add by Surendra
  refreshPage() {
    window.location.reload();
  }

  moduleCheck(item) {
    //console.log(item);
  }

  exportJunit(projectId, id, name) {
    const entity = {
      projectId: projectId,
      id: id,
    };
    this.testService.exportTestSuiteAsJunit(entity, name);
  }
  copySuite(item) {
    this.copyId = item.id;
    this.enableCopySuite = true;
    this.toastrService.clear();
    this.toastrService.info("Process copied successfully");
  }
  pasteSuite(item) {
    //console.log(item);
    this.testService
      .pasteSuite(this.projectId, item.items[0].parentTestDataId, this.copyId)
      .subscribe((data) => {
        //console.log(data);
        this.getAllChildTestDir(this.projectId);
        this.toastrService.clear();
        this.toastrService.success("Process pasted successfully");
      });
  }
  pasteSuiteFromProject(item) {
    //console.log(item);
    if (item.id != this.projectId) {
      this.toastrService.clear();
      this.toastrService.warning("Can not paste in another project");
      return;
    }
    this.testService
      .pasteSuite(this.projectId, this.projectId, this.copyId)
      .subscribe((data) => {
        //console.log(data);
        this.getAllChildTestDir(this.projectId);
        this.toastrService.clear();
        this.toastrService.success("Process pasted successfully");
      });
  }
  association(item) {
    //console.log(item);
    this.compareName = "";
    this.project.getDefaultTextData(this.projectId).subscribe((data) => {
      this.textData = data["textData"];
      //console.log(this.textData[0].name);
      this.testDataForAssociation = this.textData.filter(
        (f) => f.name == item.testDataSourceName.name
      );
      //console.log(this.testDataForAssociation.length);
      if (this.testDataForAssociation.length > 0) {
        this.compareName = this.testDataForAssociation[0].name;
        this.associationButton = true;
      } else {
        this.compareName = "";
        //  this.associationButton = true;
      }

      //console.log(this.compareName);
      //console.log(this.testDataForAssociation);
      if (this.compareName.length > 2) {
        this.disassociationButton = false;
        //console.log('hello');
      } else {
        this.disassociationButton = true;
      }
    });

    this.testService.getSuitData(this.projectId, item.id).subscribe((data) => {
      this.manageSuiteData = data;
      //console.log(data);
    });
  }
  disassociate() {
    this.testDataForAssociation;
    //console.log(this.compareName);
    var obj = {
      name: this.testDataForAssociation[0].name,
      settingName: this.testDataForAssociation[0].settingName,
    };
    //console.log(obj);
    delete this.manageSuiteData.testDataSourceName;
    //console.log(this.manageSuiteData);
    this.testService
      .editTestSuiteData(this.manageSuiteData)
      .subscribe((data) => {
        //console.log(data);
        this.toastrService.success("Entity Updated Successfully");
        this.getAllChildTestDir(this.projectId);
      });
  }

  associateData(name, settingName) {
    if (this.compareName == name) {
      this.activeState = name;
      this.disassociationButton = false;
      this.associationButton = true;
    } else if (this.compareName != name) {
      this.activeState = name;
      this.associationButton = false;
      this.disassociationButton = true;
    }

    var obj = {
      name: name,
      settingName: settingName,
    };
    this.manageSuiteData.testDataSourceName = obj;
    //console.log(this.manageSuiteData);
    // //console.log(testCasetestDataSou.rceName)
    //console.log(obj);
  }
  submitAssoiciatedData() {
    this.manageSuiteData = _.omit(this.manageSuiteData, [
      "testCaseData",
      "dynamicTestResult",
      "active",
      "execuationIteration",
      "executionCount",
      "path",
      "runState",
      "selectedState",
      "content",
    ]);
    //console.log(this.manageSuiteData);
    this.testService
      .editTestSuiteData(this.manageSuiteData)
      .subscribe((data) => {
        //console.log(data);
        this.toastrService.clear();
        this.toastrService.success("Entity Updated Successfully");
        this.getAllChildTestDir(this.projectId);
      });
  }
  importAzure(item) {
    //console.log(item);
    this.project.getAzureProject(item.projectId).subscribe((data) => {
      //console.log(data);
      this.azureData = data;
      if (this.azureData["statusCode"] == "5010") {
        this.toastrService.clear();
        this.toastrService.error(
          "Currently we are not able to connect Azure Services , Please Try Again"
        );
      }
    });
  }
  restoreSuiteData(item) {
    const arrayData = [];
    this.project
      .restoreSuite(item.projectid, item.id, arrayData)
      .subscribe((data) => {
        //console.log(data)
      });
  }
  updateSuiteData(item) {
    //console.log(item);
    this.suiteDataForUpdate = item;
    this.titleName = this.suiteDataForUpdate.title;

    this.description = this.suiteDataForUpdate.comment;
    //   //console.log('addtestSuitfromProject')
    //   this.confirmationDialogService.openAddtestSuitPopUp(item,'Update')
    //   .afterClosed().subscribe(res =>{
    //     if(res){
    //     this.getAllChildTestDir(this.projectId);

    //     }
    //  });s
    //console.log('updateModule')
  }
  checkForChange(value) {
    var titleNameCopy = this.suiteDataForUpdate.title.slice();
    if (titleNameCopy != value) {
      this.enableSubmit = true;
      //console.log(this.updateTestModuleForm.value.name);
    } else {
      this.enableSubmit = false;
    }
  }

  onModuleUpdate() {
    this.submitted = true;
    if (this.updateTestModuleForm.invalid) {
      return;
    }
    var objFormval = this.updateTestModuleForm.value;
    if (!/^[^:|*?<>/\\"]+$/.test(objFormval.name)) {
      this.toastrService.clear();
      this.toastrService.warning(
        'Process name is not Valid, Name can not contain /[<>:"/\\|?*'
      );
      return;
    }
    var valueForUpdate;

    valueForUpdate = {
      title: objFormval.name,
      comment: objFormval.comment,
      projectId: this.suiteDataForUpdate.projectId,
      id: this.suiteDataForUpdate.id,
      dependent: this.dependent,
      parentTestDataId: this.suiteDataForUpdate.parentTestDataId,
    };
    //console.log(objFormval);
    //console.log("");
    //console.log(valueForUpdate);//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/addTestFile

    //console.log(valueForUpdate);
    this.testService.editTestFile(valueForUpdate).subscribe((data) => {
      //console.log(data);
      this.cancelmodalForUpdate.nativeElement.click();
      this.project.loadSuggestion.next(true);
      this.getAllChildTestDir(this.projectId);
      this.project.sendUpdateData(data);
      this.toastrService.success("Process updated successfully");
    });
  }

  setDependent() {
    this.dependent = true;
  }
  importTestCaseData(item) {
    this.suiteIdForImportTestCase = item.id;
  }
  uploadTestCase(event: any) {
    this.testDataFile = event.target.files[0];
    this.testDataFileName = this.testDataFile.name;
  }
  resetTestDataModel() {
    this.testDataFileName = "";
    this.testDataFile = undefined;
  }
  onImportTestCase() {
    {
      if (this.testDataFile == undefined) {
        return;
      }
      //console.log("inside upload");
      var fd = new FormData();
      fd.append("file", this.testDataFile);
      //   this.toastrService.success('Uploading file ...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>', null, {
      //     extendedTimeOut: 0,
      //     timeOut: 0,
      //     enableHtml: true
      // });
      //http://beatblipdemo.agreeya.net/HuLoopRest/huloop/testImport/uploadTestCase/61276c94a1f486a24017af5e/6237f1b060b26a300fcf9b6c
      this.http
        .post(
          this.url +
            "/HuLoopRest/huloop/testImport/uploadTestCase/" +
            this.projectId +
            "/" +
            this.suiteIdForImportTestCase,
          fd
        )
        .subscribe((res) => {
          this.cancelImportTestCase.nativeElement.click();
          this.importedTestCase = res["testCaseData"];
          this.project.loadSuggestion.next(true);
          if (this.importedTestCase) {
            var testCaseName = [];
            var showToaster = false;
            var counter = 1;
            var toastrMsg = "<h5>Following Tasks are imported : <h5> <br/>";
            for (let i = 0; i < this.importedTestCase.length; i++) {
              toastrMsg +=
                counter++ + ". " + this.importedTestCase[i].title + "<br/>";
              showToaster = true;
              // testCaseName.push(this.importedTestCase[i].title);
            }

            if (showToaster) {
              this.toastrService.clear();
              this.toastrService.info(toastrMsg, null, {
                enableHtml: true,
                tapToDismiss: false,
              });
            }

            this.project.sendTestData(this.importedTestCase);
          } else {
            //console.log('no property')
            this.toastrService.clear();
            this.toastrService.warning("Selected test file already exist");
          }
        });
    }
  }
  lastExecutionReport(item) {
    this.router.navigate([
      "/report/testReport/" + item.projectId + "/" + "latest",
    ]);
  }

  selectProject(projectId: string) {
    this.highLightTestSuite = false;
    this.hightLightProject = true;
    this.highLightModule = false;
    this.highLightLocatorModule = false;
    this.highLightLocatorTestSuite = false;

    this.project.isModuleSelected.next(false);
    this.project.isLocatorModuleSelected.next(false);
    this.project.isTestSuiteSelected.next(false);
    this.project.isLocatorTestSuiteSelected.next(false)

    this.selectedProject = projectId;

    let selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    selectedProject["projectName"] = projectId;
    selectedProject["moduleName"] = "";
    selectedProject["testCaseId"] = "";
    localStorage.setItem("selectedProject", JSON.stringify(selectedProject));
  }

  selectTestCase(
    projectId: string,
    testCaseId: string,
    moduleName: string = ""
  ) {
    this.selectedProject = projectId;
    this.selectedModule = moduleName;
    this.selectedTestCaseId = testCaseId;

    this.highLightTestSuite = true;
    this.hightLightProject = false;
    this.highLightModule = false;
    this.highLightLocatorModule = false;
    this.highLightLocatorTestSuite = false;

    this.project.isModuleSelected.next(false);
    this.project.isLocatorModuleSelected.next(false);
    this.project.isTestSuiteSelected.next(true);
    this.project.isLocatorTestSuiteSelected.next(false)

    let selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    selectedProject["projectName"] = projectId;
    selectedProject["moduleName"] = moduleName;
    selectedProject["testCaseId"] = testCaseId;
    localStorage.setItem("selectedProject", JSON.stringify(selectedProject));
  }

  selectScreen(
    projectId: string,
    testScreenId: string,
    moduleName: string = ""
  ) {
    this.selectedProject = projectId;
    this.selectedModule = moduleName;
    this.selectedScreenId = testScreenId;

    this.highLightTestSuite = false;
    this.hightLightProject = false;
    this.highLightModule = false;
    this.highLightLocatorModule = false;
    this.highLightLocatorTestSuite = true;

    this.project.isModuleSelected.next(false);
    this.project.isLocatorModuleSelected.next(false);
    this.project.isTestSuiteSelected.next(false);
    this.project.isLocatorTestSuiteSelected.next(true)

    let selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    selectedProject["projectName"] = projectId;
    selectedProject["moduleName"] = moduleName;
    selectedProject["testCaseId"] = testScreenId;
    localStorage.setItem("selectedProject", JSON.stringify(selectedProject));
  }

  clearSelectedTestCase() {
    this.selectedProject = "";
    this.selectedModule = "";
    this.selectedTestCaseId = "";

    let selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    selectedProject["projectName"] = "";
    selectedProject["moduleName"] = "";
    selectedProject["testCaseId"] = "";
    localStorage.setItem("selectedProject", JSON.stringify(selectedProject));
  }

  clearSelectedScreen() {
    this.selectedProject = "";
    this.selectedModule = "";
    this.selectedTestCaseId = "";

    let selectedProject = JSON.parse(localStorage.getItem("selectedProject"));
    selectedProject["projectName"] = "";
    selectedProject["moduleName"] = "";
    selectedProject["testCaseId"] = "";
    localStorage.setItem("selectedProject", JSON.stringify(selectedProject));
  }

  filterSuggestions()
  {
    if(this.searchString.trim().length === 0)
    {
        this.showSuggestion = false;
        return;
    }
   this.matchedSuggestions = this.searchSuggestions.filter((suggestion)=>
    {
      return suggestion.includes(this.searchString.trim());
    })
    this.showSuggestion = true;
  }

  searchText()
  {
    
    this.toastrService.clear();
    this.toastrService.success('Searching please wait..');
    this.project.searchProject(this.searchString).subscribe((res)=>
    {
      this.toastrService.clear();
      if(!res)
      {
        this.toastrService.info('Sorry, no matching result found');
        return;
      }

      let keys = Object.keys(res);
      this.searchResult = [];
      let searchResultBody = document.querySelector(".searchResultBody");
      keys.forEach((key)=>
      { 
        let obj = {}
        obj['key'] = key
        let array = res[key].split(">").filter((value)=>
        {
          return value != null && value.trim().length > 0;
        });
        obj['values'] = array;
        this.searchResult.push(obj);
      })
      this.showSearchResult = true;
    })
  }

  redirectUsingId(result)
  {
    let key = result.key;
    let resultLength =  result.values.length - 1;
    let lastResult = result.values[resultLength];
    let a = lastResult.lastIndexOf("(");
    let resultType = lastResult.slice(a, lastResult.length);
   
    let ids = key.split("+");

    switch(resultType)
    {
        case "(P)":
          this.router.navigate([ "/report/project-report/" + ids[0] ]);
          break;
        case "(TSD)":
          break;
        case"(TS)":
        this.router.navigate(["/test/TestSuit/" + ids[0] + '/' + ids[2]]) ;
        break;
        case"(TC)":
        this.router.navigate(["/test/TestStep/" + ids[0] + '/' + ids[2] + "/" + ids[3] ]) ;
        break;
        default :
        break;
    }

  }

  selectSuggestion(suggestion)
  {
    this.searchString = suggestion;
    this.showSuggestion = false;
  }

  ngAfterViewChecked() {
    // this.subscriptionForNewProject = this.project.getSharedProjectId().subscribe(
    //   (data)=>{
    //     //console.log('sharedProjectId',data);
    //     setTimeout(() => {
    //       this.getAllChildTestDir(data);
    //     }, 2000);
    //   }
    // )
  }

  importRecordedData(item){
    this.testId = item.id;

  }
  resetSeleniumModel()
  {
    this.seleniumFileName = "";
    this.seleniumFile = File;
    this.enableseleniumButton=false;
  }
  uploadSeleniumData(event : any)
  {
    this.resetSeleniumModel();
    this.enableseleniumButton=true;
    //console.log(event);
   this.seleniumFile  = event.target.files[0];
   this.seleniumFileName =  this.seleniumFile.name.substring(0, this.seleniumFile.name.lastIndexOf('.'));
  }
  onImportSeleniumFile()
  {
    if(this.seleniumFile == undefined)
    {
        return;
    }

    var fd = new FormData();
    fd.append('file', this.seleniumFile);

    this.http.post(this.url+'/HuLoopRest/huloop/testImport/uploadSelenium/' + this.projectId + "/" + this.testId, fd).subscribe((res)=>
    {
      this.seleniumFileName = "";
      this.toastrService.success("Recorded file uploaded successfully");
      this.cancelSeleniumDataScreen.nativeElement.click();
      // this.reloadComponent();
      this.project.sendUpdateData(res);

      // this.initTestCaseData();
    });

  }

  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }
    resetForm(){
      // this.suiteDataForUpdate = item;
      console.log(this.titleName);
      
     
   
      
    }

    getModuleData(projectId){
      this.http
      .get(this.url + "/HuLoopRest/huloop/" + "test/all/" + projectId)
      .subscribe((data) => {
        console.log(data);
        
      }
      )
    }
    getSuiteData(){

    }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription1) {
      this.subscription.unsubscribe();
    }
  }
}

// @Pipe({ name: 'removeComa' })
// export class RemoveUnderscorePipe implements PipeTransform {
//   transform(value: any, args?: any): any {
//     return value.replace(/,/g, " ");
//   }
// }
